import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useContainerMediaQueriesChecks} from "../../../../hooks/use-container-media-queries-checks.hook";
import {useServices} from "../../../../hooks/use-services.hook";
import {
    ICardNetworkViewModel
} from "../../../../services/booking/models/payment/methods/card/networks/card-network.view-model.interface";

const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap24};
    width: 100%;
`

const CardNetworkBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${props => props.theme.spacing.flexGap16};
    width: 100%;
`

const TitleBox = styled.div`
    color: ${props => props.theme.colors.secondaryShade};
    font-size: ${props => props.theme.fontSize.h4};
    font-weight: ${props => props.theme.fontWeight.bold};
    width: 100%;
    text-align: center;
`

const SubtitleBox = styled.div`
    width: 100%;
    align-items: center;
    font-size: ${props => props.theme.fontSize.body2};
    color: ${props => props.theme.colors.mediumTint};
    text-align: center;
`

interface SupportedCardNetworksLargeComponentProps {
    networks: ICardNetworkViewModel[];
}
export const SupportedCardNetworksLargeComponent: React.FC<SupportedCardNetworksLargeComponentProps> = observer((props) => {
    const services = useServices();
    const mediaQuery = useContainerMediaQueriesChecks();
    const renderOneNetwork = (pm: ICardNetworkViewModel) => {
        return <div key={pm.code}>{pm.renderIcon({
            useSmallIcon: mediaQuery.smallScreen
        })}</div>
    }

    return (
        <ContainerBox>
            <TitleBox>{services.language.translate('You can easily secure your seat by paying with any of the trusted credit or debit card providers listed below.')}</TitleBox>
            <CardNetworkBox>
                {props.networks.map(renderOneNetwork)}
            </CardNetworkBox>

            <SubtitleBox dangerouslySetInnerHTML={{
                __html: services.language.translate('Click <b>Pay</b> button to continue.')
            }}/>

        </ContainerBox>
    )
})